import { render, staticRenderFns } from "./PortDoor.vue?vue&type=template&id=2835f44b"
import script from "./PortDoor.vue?vue&type=script&lang=js"
export * from "./PortDoor.vue?vue&type=script&lang=js"
import style0 from "./PortDoor.vue?vue&type=style&index=0&id=2835f44b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports